module.exports = __webpack_public_path__ + "static/media/LinkedIn icon.5a676cf6.svg";